// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  WORKPLAN_SET_LOADING,
} from './constants';

export function setLoading() {
  return {
    type: WORKPLAN_SET_LOADING,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKPLAN_SET_LOADING:
      return {
        ...state,
        loading:true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/workplan/redux/setLoading.js